import validate from "/build/incl/node_modules/.pnpm/nuxt@3.16.1_@types+node@18.19.6_eslint@8.55.0_rollup@2.79.1_sass@1.69.5_tsx@4.19.2_typescript@5.6.2_vite@4.5.1/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/build/incl/node_modules/.pnpm/nuxt@3.16.1_@types+node@18.19.6_eslint@8.55.0_rollup@2.79.1_sass@1.69.5_tsx@4.19.2_typescript@5.6.2_vite@4.5.1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/build/incl/middleware/auth.ts"),
  "open-feature": () => import("/build/incl/middleware/openFeature.ts"),
  role: () => import("/build/incl/middleware/role.ts")
}